import { useLocation } from "react-router-dom";

import { OfferBgOne, OfferBgTwo } from "./components";
import { OFFER_CARDS } from "./constants/Offer.constants";
import "./offer.scss";

const Offer = () => {
  let location = useLocation();

  const offerBg1 = () => {
    return <>{location.pathname === "/home" ? <OfferBgOne /> : null}</>;
  };

  return (
    <div id="offer">
      <div className="container">
        <div className="title ">
          <h5 className="text-center font_change_color">Specialized In</h5>
          <h1 className="text-center" style={{ position: "relative" }}>
            What I Offer
            {offerBg1()}
          </h1>
        </div>
        <div className="row d-flex justify-content-center m-0">
          {OFFER_CARDS.map((offer, i) => {
            return (
              <div className="col-12 col-md-6 col-lg-4 mb-2 mb-md-5" key={i}>
                <div className="offer_block">
                  <div className="icon">
                    <i className={offer.icon}></i>
                  </div>
                  <h4>{offer.title}</h4>
                  <p className="mb-0">{offer.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <OfferBgTwo />
    </div>
  );
};

export default Offer;
